import styles from './FJMobileGenerateSuccessful.module.less';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJMobileBG from '../../../common/components/FJMobileBG/FJMobileBG.jsx';
import MobileEditIcon from '../../../assets/svg/mobile-edit.svg?react';
import FJImage from '../../../common/components/FJImage/FJImage.jsx';
import classNames from 'classnames';
import FJIconButton from '../../../common/components/FJIconButton/FJIconButton.jsx';
import DownloadIcon from '../../../assets/svg/download.svg?react';
import bgBase64 from '../../../assets/base64/generate-successful-bg.js';
import congratulateBase64 from '../../../assets/base64/congratulate.js';
import PropTypes from 'prop-types';
import FJConstant from '../../../constants/FJConstant.js';
import FJFileUpload from '../../../common/components/FJFileUpload/FJFileUpload.jsx';
import FJMobileHeaderLine from '../../../common/components/FJMobileHeaderLine/FJMobileHeaderLine.jsx';
import { useState, useRef, useEffect, useMemo } from 'react';
import FJHoverBoardGradation from '../../../common/components/FJHoverBoard/FJHoverBoardGradation.jsx';

const FJMobileGenerateSuccessful = props => {
    const {
        onDownload,
        gotoBack,
        onReEdit,
        onPreview,
        taskStatus,
        gotoBackText = 'back',
        reEditText,
        imageRect = {},
        reEditHasUpload = true,
        previewList = [],
        previewIndex,
        setPreviewIndex,
    } = props;
    const contentRef = useRef(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [imgStyle, setImgStyle] = useState({});

    const [touchStart, setTouchStart] = useState(0);
    const [touchEnd, setTouchEnd] = useState(0);
    const [isDragging, setIsDragging] = useState(false);

    const previewItem = useMemo(() => {
        return previewList[previewIndex] || previewList[0] || {};
    }, [previewIndex, previewList]);
    const _onDownload = () => {
        setIsDownloading(true);
        onDownload(() => setIsDownloading(false));
    };

    const _gotoBack = () => {
        gotoBack && gotoBack(previewItem);
    };
    const _onPreview = () => {
        onPreview(previewItem);
    };
    //#region 触摸切图事件

    const switchPreview = (isNext = true) => {
        const nextIndex = isNext ? previewIndex + 1 : previewIndex - 1;
        if (previewList[nextIndex]) {
            setPreviewIndex(nextIndex);
        }
    };
    // 处理触摸开始
    const _handleTouchStart = e => {
        setTouchStart({ x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY });
        setIsDragging(true);
    };

    // 处理触摸移动
    const _handleTouchMove = e => {
        if (!isDragging) return;
        setTouchEnd({ x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY });
    };

    // 处理触摸结束
    const _handleTouchEnd = () => {
        setIsDragging(false);

        if (!touchStart || !touchEnd) return;

        const horizontalDistance = touchStart.x - touchEnd.x;
        const minHorizontalSwipeDistance = 50; // 水平最小滑动距离

        if (Math.abs(horizontalDistance) > minHorizontalSwipeDistance) {
            //水平切换图片
            if (horizontalDistance > 0) {
                switchPreview(true);
            } else {
                switchPreview(false);
            }
        }

        setTouchStart(0);
        setTouchEnd(0);
    };
    //#endregion
    useEffect(() => {
        if ((imageRect.width || imageRect.height) && contentRef.current) {
            const { width, height } = contentRef.current.getBoundingClientRect();
            const maxW = width - 32;
            const maxH = height * 0.58;
            const ratio = imageRect.width / imageRect.height;
            if (ratio > maxW / maxH) {
                setImgStyle({
                    width: maxW,
                    height: maxW / ratio,
                });
            } else {
                setImgStyle({
                    width: maxH * ratio,
                    height: maxH,
                });
            }
        }
    }, [imageRect, contentRef]);
    const _renderReEditBtn = () => {
        if (reEditHasUpload) {
            return (
                <FJFileUpload onUpload={onReEdit} className={styles.btn}>
                    <FJIconButton
                        className={styles.restore_btn}
                        text={reEditText}
                        icon={<MobileEditIcon />}
                        textClassName={styles.btn_text}
                    />
                </FJFileUpload>
            );
        } else {
            return (
                <FJIconButton onClick={onReEdit} className={styles.btn} text={reEditText} icon={<MobileEditIcon />} />
            );
        }
    };
    const downloadText = previewList.length > 1 ? FJLocalStore._('download-all') : FJLocalStore._('download');
    return (
        <FJMobileBG
            className={styles.container}
            active={taskStatus === FJConstant.SUCCESS}
            style={{ backgroundImage: `url(${bgBase64})` }}
        >
            <FJMobileHeaderLine gotoBackText={FJLocalStore._(gotoBackText)} gotoBack={_gotoBack} />
            <div
                className={styles.content}
                ref={contentRef}
                onTouchStart={_handleTouchStart}
                onTouchMove={_handleTouchMove}
                onTouchEnd={_handleTouchEnd}
            >
                <div className={styles.content_title_box}>
                    <img className={styles.congratulate_img} src={congratulateBase64} />
                    <div className={styles.content_title}>{FJLocalStore._('success')}</div>
                </div>
                <FJImage
                    imgSrc={previewItem?.imgUrl}
                    boxClassName={classNames(styles.img_box)}
                    onClick={_onPreview}
                    style={imgStyle}
                    isShowLoading={true}
                />
                {previewList.length > 1 && (
                    <div className={styles.preview_list_box}>
                        {previewList.map((item, index) => (
                            <FJHoverBoardGradation
                                key={item.id}
                                className={classNames(styles.preview_list_item)}
                                contentClassName={styles.preview_list_item_content}
                                active={previewIndex === index}
                                borderRadius={6}
                                onClick={() => setPreviewIndex(index)}
                            >
                                <FJImage
                                    key={index}
                                    imgSrc={item.imgUrl}
                                    boxClassName={classNames(styles.preview_list_item_img)}
                                />
                            </FJHoverBoardGradation>
                        ))}
                    </div>
                )}
                <FJIconButton
                    className={classNames(styles.btn, styles.margin_top_24)}
                    text={downloadText}
                    onClick={_onDownload}
                    isLoading={isDownloading}
                    type={'gradient'}
                    icon={<DownloadIcon />}
                    textClassName={styles.btn_text}
                />

                {_renderReEditBtn()}
            </div>
        </FJMobileBG>
    );
};

FJMobileGenerateSuccessful.propTypes = {
    onDownload: PropTypes.func,
    gotoBack: PropTypes.func,
    onReEdit: PropTypes.func,
    onPreview: PropTypes.func,
    data: PropTypes.object,
    taskStatus: PropTypes.string,
    gotoBackText: PropTypes.string,
    reEditText: PropTypes.string,
    imageRect: PropTypes.object,
    reEditHasUpload: PropTypes.bool,
    previewList: PropTypes.array,
    previewIndex: PropTypes.number,
    setPreviewIndex: PropTypes.func,
};

export default FJMobileGenerateSuccessful;
